module.exports = __webpack_public_path__ + "img/BSRN.34b195b9.webp";